import { deserialize, serialize, inheritSerialization } from "cerialize";

import BaseEntity from "../BaseEntity";
import TableColumn from "../TableColumn";


import moment from "moment";
import 'moment/locale/id';
import { getPenerimaDana } from "../../util/PluralVariabels";

@inheritSerialization(BaseEntity)
export default class TUKIncome extends BaseEntity {

  @serialize
  @deserialize
  public wilayah: string = "";

  @serialize
  @deserialize
  public bendahara_type: string = "";

  @serialize
  @deserialize
  public jenis_pemasukan_id: number = 0;

  @serialize
  @deserialize
  public jenis_pemasukan_name: string = "";

  @serialize
  @deserialize
  public tanggal_pemasukan: string = "";

  @serialize
  @deserialize
  public nominal: number = 0;

  @serialize
  @deserialize
  public keterangan: string = "";

  @serialize
  @deserialize
  public source_type: string = "MANUAL";

  @serialize
  @deserialize
  public created_at: string = "";

  public hasValid(): boolean {
    return Boolean(this.tanggal_pemasukan) &&
      this.jenis_pemasukan_id > 0 &&
      this.nominal > 0 &&
      Boolean(this.bendahara_type);
  }

  // Feedback methods for form validation
  public tanggalPemasukanFeedback() {
    return this.defaultPropertyFeedback('tanggal_pemasukan', Boolean(this.tanggal_pemasukan));
  }

  public bendaharaTypeFeedback() {
    return this.defaultPropertyFeedback('bendahara_type', Boolean(this.bendahara_type));
  }

  public jenisPemasukanFeedback() {
    return this.defaultPropertyFeedback('jenis_pemasukan_id', this.jenis_pemasukan_id > 0);
  }

  public nominalFeedback() {
    return this.defaultPropertyFeedback('nominal', this.nominal > 0);
  }

  public wilayahFeedback() {
    return this.defaultPropertyFeedback('wilayah', Boolean(this.wilayah));
  }

  public table() {
    const {
      wilayah,
      tanggal_pemasukan,
      jenis_pemasukan_name,
      nominal,
      keterangan
    } = this;
    moment.locale('id');
    return {
      wilayah: getPenerimaDana(wilayah),
      tanggal_pemasukan: moment(tanggal_pemasukan).format('dddd, DD MMM YYYY'),
      jenis_pemasukan: jenis_pemasukan_name,
      nominal,
      keterangan
    };
  }

  public static columnName(): Array<TableColumn> {
    const income = new TUKIncome().table();
    let keys = Object.keys(income);

    return keys.map((field: any) => {
      const tableColumn = new TableColumn();
      const labels: any = {
        wilayah: 'Wilayah',
        tanggal_pemasukan: 'Tanggal Pemasukan',
        jenis_pemasukan: 'Jenis Pemasukan',
        nominal: 'Nominal',
        keterangan: 'Keterangan'
      };
      tableColumn.name = labels[field] || field;
      return tableColumn;
    });
  }
}
